__turbopack_context__.v({
  "col": "FlipDeck-module-scss-module__tZOXyG__col",
  "dots": "FlipDeck-module-scss-module__tZOXyG__dots",
  "flushBottom": "FlipDeck-module-scss-module__tZOXyG__flushBottom",
  "flushTop": "FlipDeck-module-scss-module__tZOXyG__flushTop",
  "inner": "FlipDeck-module-scss-module__tZOXyG__inner",
  "isCreamHeavy": "FlipDeck-module-scss-module__tZOXyG__isCreamHeavy",
  "light": "FlipDeck-module-scss-module__tZOXyG__light",
  "mediaWrapper": "FlipDeck-module-scss-module__tZOXyG__mediaWrapper",
  "nav": "FlipDeck-module-scss-module__tZOXyG__nav",
  "navArrow": "FlipDeck-module-scss-module__tZOXyG__navArrow",
  "root": "FlipDeck-module-scss-module__tZOXyG__root",
});
